import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {cartItemInterface} from "./cartItemInterface";
import {getWizardGroupFromCurrentSteps} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";


const ShoppingCartItemsListItemEditButton = (props) => {

  const {cartItem, handleEditClick, isMobile, wizardList, allWizardsValues} = props;

  const isEditable = useMemo(() => {
    if (cartItem.fromWizardGroupId && allWizardsValues) {
      const neededObject = allWizardsValues.find(wizValueObject => (wizValueObject.quoteIndex === cartItem.currentQuote)
        && (wizValueObject.wizardItemId === cartItem.fromWizardId));
      const selectedWizValues = neededObject && neededObject.wizardSelectedValues ? neededObject.wizardSelectedValues : null;
      const wizardItem = wizardList.find(wizItem => wizItem.id === cartItem.fromWizardId);
      const {neededStep} = getWizardGroupFromCurrentSteps(wizardItem, selectedWizValues, cartItem.fromWizardGroupId);
      if (!neededStep) {
        return false
      }
    }
    return true
  }, [allWizardsValues, wizardList, cartItem])

  if (!isEditable) {
    return null
  }

  if (isMobile) {
    return (
      <button className="ui-smallbutton ui-smallbutton--edit" onClick={handleEditClick}/>
    )
  }

  return (
    <span className="link link--blue" onClick={handleEditClick}>
      <FormattedMessage id="shoppingCart.featureInCartEditLink"/>
    </span>
  )
}

ShoppingCartItemsListItemEditButton.propTypes = {
  handleEditClick: PropTypes.func.isRequired,
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {allWizardsValues, wizardList} = store.wizardState;
  const {isMobile} = store.serverState;

  return {
    wizardList,
    allWizardsValues,
    isMobile,
  };
};

export default connect(mapStateToProps)(ShoppingCartItemsListItemEditButton)
